module.exports = __webpack_public_path__ + "media/images/emblems/Schuepfheim_LU-f52dabbc21ca5b4119d357ef995f42b9.png";